import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import ModalFlexible from 'saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible';
import  RadioList from 'saur_ui_library/src/Molecules/RadioList/RadioList';
import Checkbox from 'saur_ui_library/src/Atoms/Input/Checkbox/Checkbox';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import { saveAs } from "file-saver";
import Loader from "./Loader";
import React, { FC, useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { ExportApi, ParameterApi, FilterApi } from "../../utils/api";
import AutocompleteComponent from './component/AutocompleteComponent';
import Error from "./ErrorMessage";
import moment from "moment";
import { dateFr, maximumDate } from "../../utils/helper";
import { inputTextDate, dataService2 } from "../../utils/helpers/view/detailsHelper";
import { Toast } from "primereact/toast";
import {SET_JOBSLAUNCH} from "../../redux/actionType";
import { useDispatch } from "react-redux";
import ModernDatePicker from './component/ModernDatePicker';
import { PopupComponent } from '../../utils/helpers/table/tableHelper';
import { createRoot } from 'react-dom/client';
type ExportProps = {
  IsVisible: any;
  setModalVisible: any;
};
type formType = {
  startDate: null | any;
  endDate: null | any;
  contract: null | any;
  install: null | any;
  module: null | any;
  typeH2s: null | any;
};

const Export: FC<ExportProps> = (props) => {
  // Get contractCode
  const contractCode = window.sessionStorage.getItem('contractCode') || '';

  //Reset
  useEffect(() => {
    setValidation(() => ({
      startDate: null,
      endDate: null,
      contract: null,
      install: null,
      module: null,
      typeH2s: null,
    }));
    setForm(() => ({
      startDate: null,
      endDate: null,
      contract: window.sessionStorage.getItem("contractId")!,
      install: null,
      module: null,
      typeH2s: null,
    }));
  }, [props.IsVisible]);

  //Form fields
  const [form, setForm] = React.useState<formType>({
    startDate: null,
    endDate: null,
    contract: null,
    install: null,
    module: null,
    typeH2s: null,
  });
//to test if h2S is select and show type
  const formH2SType = form.module === "H2S";
  const dispatch = useDispatch();

  //Values for install types
  const [checkBoxValuesType, setcheckBoxValuesType] = React.useState([
    { id: 1, value: false, label: "DO" },
    { id: 2, value: false, label: "TP" },
    { id: 3, value: false, label: "PR" },
    { id: 4, value: false, label: "MR" },
    { id: 5, value: false, label: "STEP" },
  ]);
  const [checkBoxDownload, setCheckBoxDownload] =
    React.useState<boolean>(false);

  const radioValuesType = [
    { id: 1, label: "Journalier" },
    { id: 2, label: "Horaire" },
  ];

  dataService2.getError().subscribe((errorState: any) => {
    setError(errorState);
  });

  //Variable for the charged data
  const [installData, setInstallData] = React.useState([]);
  const moduleData = [
    { id: 1, type: "PR/DO" },
    { id: 2, type: "ECP" },
    { id: 3, type: "H2S" },
  ];
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const toastInfo = React.useRef<any>(null);

  //Function to call the export api
  const ExportCsv = async () => {
    try {
      setLoading(true);

      const startDate =
        form.startDate.year +
        "-" +
        form.startDate.month +
        "-" +
        form.startDate.day;

      const endDate =
        form.endDate.year + "-" + form.endDate.month + "-" + form.endDate.day;
  
      let response: any;
      let type = "";

      if (form.module === "PR/DO") {
        response = await ExportApi.exportZipPrDo(
          form.install,
          moment(startDate).format("YYYY-MM-DD"),
          moment(endDate).format("YYYY-MM-DD")
        );
        type = "pr/do";
      } else if (form.module === "H2S") {
        if (form.typeH2s === "Journalier") {
          console.log('from Journalier');
          
          response = await ExportApi.exportZipEcpH2s(
            form.install,
            moment(startDate).format("YYYY-MM-DD"),
            moment(endDate).format("YYYY-MM-DD"),
            "macro",
            contractCode
          );
          type = "h2s macro";
        } else {
          console.log('from else');

          response = await ExportApi.exportZipEcpH2s(
            form.install,
            moment(startDate).format("YYYY-MM-DD"),
            moment(endDate).format("YYYY-MM-DD"),
            "micro",
            contractCode
          );
          type = "h2s micro";
        }
      } else if (form.module === "ECP") {
        response = await ExportApi.exportZipEcpH2s(
          form.install,
          moment(startDate).format("YYYY-MM-DD"),
          moment(endDate).format("YYYY-MM-DD"),
          "ecp",
          contractCode
        );
        type = "ecp";
      }

      if (response.headers["content-type"] === "application/zip") {
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        const filename =
          "export-" +
          type +
          "-" +
          form.install +
          "-" +
          moment().utc().format("YYYY-MM-DD") +
          ".zip";
        saveAs(blob, filename);
      } else {
        const blob = new Blob(["\ufeff" + response.data], {
          type: "data:text/csv;charset=utf-8,",
        });
        const filename =
          "export-" +
          type +
          "-" +
          form.install +
          "-" +
          moment().utc().format("YYYY-MM-DD") +
          ".csv";
        saveAs(blob, filename);
      }

      setLoading(false);
    } catch (e) {
      setLoading(false);
      setError(true);
    }
  };

  //Use effects
  useEffect(() => {
    if (!form.contract) return;
  
    const getInstall = async () => {
      let types: string[] = [];
      checkBoxValuesType.forEach((type) => {
        if (type.value === true) {
          types.push("MDI_" + type.label);
        }
      });
  
      const response = await FilterApi.getInstall(form.contract, types.toString());
      setInstallData(response.data);
    };
  
    getInstall();
  }, [form.contract, checkBoxValuesType]);
  

  //OnChange functions

  const onInstallChange = (event: any, install: any) => {
    setForm((oldValues) => {
      return {
        ...oldValues,
        install: install ? install.mainInstallCode : null,
      };
    });
  };

  const onModuleChange = (event: any, module: any) => {
    setForm((oldValues) => {
      return {
        ...oldValues,
        module: module ? module.name : null,
      };
    });
  };

  //Form fields validation
  const [validation, setValidation] = React.useState<{
    startDate: null | any;
    endDate: null | any;
    contract: null | any;
    install: null | any;
    module: null | any;
    typeH2s: null | any;
  }>({
    startDate: null,
    endDate: null,
    contract: null,
    install: null,
    module: null,
    typeH2s: null,
  });

  function handleOnSubmit() {
    setValidation(() => ({
      startDate: form.startDate ? null : "date de début manquante",
      endDate: form.endDate ? null : "date de fin manquante",
      contract: form.contract ? null : "contrat manquant",
      install: form.install ? null : "installation manquante",
      module: form.module ? null : "module manquant",
      typeH2s:
        !form.typeH2s && form.module === "H2S" ? "type h2s manquant" : null,
    }));
    beforeSubmit();
  }

  async function beforeSubmit() {
    if (
     form.startDate !== null &&
      form.endDate !== null &&
      form.contract !== null &&
      form.install !== null &&
      ((form.module !== null &&  form.module !== "H2S")
      ||
      ( form.typeH2s!==null  && form.module === "H2S"))
    ) {
      ExportCsv();
    }
  }

  async function calculateJobs() {
    if (form.startDate !== null && form.endDate !== null) {
      const finalStart: string =
      form.startDate.year +
      "-" +
      form.startDate.month +
      "-" +
      form.startDate.day;

    const finalEnd :string =
      form.endDate.year + "-" + form.endDate.month + "-" + form.endDate.day;
      const param = {
        contractCode: window.sessionStorage.getItem("contractCode") || "",
        startDate:moment(finalStart).format("YYYY-MM-DD"),
        endDate: moment(finalEnd).format("YYYY-MM-DD"),
      };
       
      try {
        await ParameterApi.sparkDownloadFolder(param).then((value: any) => {
          if (value.status === 201) {
            toastInfo.current?.show({
              severity: "info",
              summary: "Lancement du téléchargement",
              detail:
                " Votre demande est bien prise en compte. Vous pourrez télécharger dans l'onglet partage dans quelques minutes ",
              life: 15000,
            });
            dispatch({
              type: SET_JOBSLAUNCH,
              payload: {
                jobId: value?.data.jobId,
                runId: value?.data.id,
              },
            });
          }
        });
      } catch (e) {
        toastInfo.current?.show({
          severity: "error",
          summary: "Téléchargement échoué ",
          detail:
            " Nous avons rencontré un soucis dans la prise en compte de votre demande. Veuillez réessayer ou contacter votre administrateur",
          life: 15000,
        });
      }
    }
  }

  const popupContent = () => (
    <Container className='modalSizeContainer'>
      <Form onSubmit={handleOnSubmit}>
        <Word
          variant='p'
          textStyle='title'
          value='Intervalle'
          className='fieldLabel'
        />
        <Container className='formLineDate'>
          <Container className='formLineDateItem'>
            <ModernDatePicker
              className='datePick'
              inputPlaceholder='Du'
              value={form.startDate}
              locale={dateFr}
              maximumDate={maximumDate()}
              formatInputText={() => {
                return inputTextDate(form.startDate);
              }}
              onChange={(date) => {
                setForm((oldValues) => {
                  return { ...oldValues, startDate: date };
                });
              }}
            />
          </Container>
          <Container className='formLineDateItem'>
            <ModernDatePicker
              className='datePick'
              inputPlaceholder='Au'
              value={form.endDate}
              locale={dateFr}
              minimumDate={form.startDate}
              maximumDate={maximumDate()}
              formatInputText={() => {
                return inputTextDate(form.endDate);
              }}
              onChange={(date) => {
                setForm((oldValues) => {
                  return { ...oldValues, endDate: date };
                });
              }}
            />
          </Container>
        </Container>

        <Container className='formLineError'>
          <Container className='formLineDateErrorItem'>
            <Word
              className='error'
              textStyle='normalReg'
              variant='span'
              value={validation.startDate}
            />
          </Container>
          <Container className='formLineDateErrorItem'>
            <Word
              className='error'
              textStyle='normalReg'
              variant='span'
              value={validation.endDate}
            />
          </Container>
        </Container>
        <Word
          variant='p'
          textStyle='title'
          value='Exporter tout le contrat'
          className='fieldLabel'
        />
        <Container key='download-contract' className='formLineTypeItem'>
          <Checkbox
            key={1}
            id={1}
            automatedTestId='export-dl-all'
            checked={checkBoxDownload}
            onChange={(e) => {
              setCheckBoxDownload(e.value);
            }}
          />
          <Container className='formLineError'>
            <Word
              className='error'
              textStyle='normalReg'
              variant='span'
              value=''
            />
          </Container>
        </Container>
        {!checkBoxDownload ? (
          <>
            <Word
              variant='p'
              textStyle='title'
              value='Type'
              className='fieldLabel'
            />
            <Container className='formLineType'>
              {checkBoxValuesType.map((v) => {
                return (
                  <Container key={v.id} className='formLineTypeItem'>
                    <Checkbox
                      id={v.id}
                      checked={v.value}
                      onChange={(x) => {
                        const nextValues = checkBoxValuesType.map((cv) => {
                          if (cv.id === x.id) {
                            return { ...x, label: cv.label };
                          }
                          return cv;
                        });
                        setcheckBoxValuesType(nextValues);
                      }}
                    />
                    <Word
                      className='label-chckb'
                      textStyle='normalMed'
                      value={v.label}
                      variant='span'
                    />
                  </Container>
                );
              })}
            </Container>
            <Word
              value='Installation'
              textStyle='title'
              variant='p'
              automatedTestId='id-installation'
              className='fieldLabel'
            />
            <Container className='formLineInstall'>
              {
                <Container className='formLineInstallItem'>
                  <AutocompleteComponent
                    id='export-filtre-install'
                    Listoption={installData.map((c: any) => {
                      return { ...c, name: c.mainInstallLabel };
                    })}
                    onChangeValue={onInstallChange}
                  />
                </Container>
              }
            </Container>
            <Container className='formLineError'>
              <Word
                className='error'
                textStyle='normalReg'
                variant='span'
                value={validation.install}
              />
            </Container>
            <Word
              value='Module'
              textStyle='title'
              variant='p'
              automatedTestId='id-module'
              className='fieldLabel'
            />
            <Container className='formLineModule'>
              <Container className='formLineModuleItem'>
                <AutocompleteComponent
                  id='export-module'
                  Listoption={moduleData.map((c: any) => {
                    return { ...c, name: c.type };
                  })}
                  onChangeValue={onModuleChange}
                />
              </Container>
            </Container>
            <Container className='formLineError'>
              <Word
                className='error'
                textStyle='normalReg'
                variant='span'
                value={validation.module}
              />
            </Container>
            {formH2SType ? (
              <>
                <Word
                  value='MICRO/MACRO'
                  textStyle='title'
                  variant='p'
                  automatedTestId='id-module'
                  className='fieldLabel'
                />
                <Container className='formLineTypeH2s'>
                  <RadioList
                    className='formLineTypeH2sItem'
                    values={radioValuesType}
                    onChange={(x) => {
                      setForm((oldValues) => {
                        return {
                          ...oldValues,
                          typeH2s: x.label ? x.label : null,
                        };
                      });
                    }}
                  />
                </Container>
              </>
            ) : null}
            <Container className='formLineError'>
              <Word
                className='error'
                textStyle='normalReg'
                variant='span'
                value={validation.typeH2s}
              />
            </Container>
            <Container className='formLineButtonItem'>
              {
                <StyledSectionButton>
                  <Button className='export-btn' mode='plain'>
                    <Word
                      variant='span'
                      textStyle='normalBold'
                      value='Exporter CSV'
                    />
                  </Button>
                </StyledSectionButton>
              }
            </Container>
          </>
        ) : null}
        {checkBoxDownload ? (
          <Container className='formLineButtonItem'>
            {
              <StyledSectionButton>
                <Button
                  className='export-btn'
                  mode='plain'
                  onClick={() => {
                    calculateJobs();
                  }}
                >
                  <Word
                    variant='span'
                    textStyle='normalBold'
                    value='Télécharger'
                  />
                </Button>
              </StyledSectionButton>
            }
          </Container>
        ) : null}
      </Form>
    </Container>
  );

  //Html
  return (
    <Container>
      <Styles />
      <Toast id='toast-info' ref={toastInfo} />
      <ModalFlexible
        showHeader
        className='exportContainer'
        title='Export de données'
        toggleModal={props.setModalVisible}
        visible={props.IsVisible}
        desktopContent={popupContent}
      />
      {loading ? (
        <Container automatedTestId='loader' className='loader'>
          <Loader IsVisible={true} />
        </Container>
      ) : null}
      {error ? <Error IsVisible={error}></Error> : null}
    </Container>
  );
};
const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
`;
const Styles = createGlobalStyle`
.sds-reset-style{
.exportContainer{
  z-index:200;  
  div.modal-flex-desktop-content{
    width: 100vh;
  }
.modalSizeContainer{
 margin-bottom: 2%;
 color: black !important;
  .formLineDate {
    flex-direction: row;
    justify-content: space-between;
    margin-bottom:4px
  }
  .formLineType {
    flex-direction: row;
    margin-bottom:35px;
  }
  .formLineInstall {
    flex-direction: row;
    margin-bottom:15px;
  }
  .formLineModule {
    flex-direction: row;
    margin-bottom:15px;
  }
  .formLineTypeH2s {
    flex-direction: row;
    margin-bottom:15px;
  }
  .formLineDateItem {
    align-items: center;
    position: relative;
    background-color:#edf2fa;
    width: 48%;
  }
  .formLineTypeItem {
    width: 15%;
    flex-direction: row;
  }
  .formLineInstallItem {
    width: 100%;
  }
  .formLineModuleItem {
    width: 100%;
  }
  .formLineTypeH2sItem {
  }
  .formLineButtonItem {
    align-items: center;
    margin-right: 4%;
  }
  .formLineError {
    flex-direction: row;
    justify-content: space-between;
    margin-bottom:15px;
    height:20px;
    .error{
        color:red
      }
  }
  .download-contract{
   margin-bottom: 5px;
  }
  .formLineDateErrorItem {
    align-items: center;
    position: relative;
    width: 48%;
  }
  .fieldLabel{
    margin-bottom:8px;
  }
  .datePick{
    background-color:#edf2fa;
    border-color:#edf2fa;
  }
  .sds-m-modern-date-picker{
    margin-bottom:0px !important;
  }
  .sds-m-modern-date-picker .my-custom-input{
    background-color:#edf2fa;
    border-color:#edf2fa;
  }
  .dropdown-icon-date {
    position: absolute;
    right: 20px;
    width: 28px;
    height: 28px;
    top: 50%;
    transform: translateY(-50%);
    z-index:99;
  }
  .label-chckb{
    margin-left:5%;
  }
  .dropdown-icon-container svg{
    width:15px;
  }
}
}
.modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position .modal-flex-desktop-content .modal-flex-desktop-header {
    align-items: flex-end !important;
    padding: 0px !important;
    height: max-content;
    flex-direction: column !important;
  }
  .sds-word.title.modal-flex-desktop-content-title {
    color: black !important;
  }
  .modal-flex-mobile-header{
    display: none;
  }
}
`;
export default Export;
